import React from 'react';
import Navbar from '../Navigation';
import { LayoutWrapper, ContentWrapper } from './style';
import { useLocation } from 'react-router-dom';

import DataSyncClock from '../DataSyncClock';
import useOnlineStatus from '@msales/shared/hooks/useOnlineStatus';
import VersionInfo from '../VersionInfo';
import { isCanaryMode, canaryTheme } from '../../utils/canaryMode';

const Layout = ({ children }) => {
  const location = useLocation();
  const isOnline = useOnlineStatus();

  const showNavbar =
    location.pathname !== '/reports/salesmans/map' &&
    location.pathname !== '/home' &&
    location.pathname !== '/device-approval';

  return (
    <LayoutWrapper
      style={
        isCanaryMode
          ? {
              border: `3px solid ${canaryTheme.primary}`,
              boxSizing: 'border-box',
            }
          : undefined
      }
    >
      <div style={{ flexShrink: 0 }}>
        <DataSyncClock isOnline={isOnline} />
      </div>

      {children}

      <div style={{ flexShrink: 0 }}>
        <VersionInfo />
        {showNavbar && <Navbar />}
      </div>
    </LayoutWrapper>
  );
};

export const Content = ({ children, style }) => {
  return <ContentWrapper style={style}>{children}</ContentWrapper>;
};

export * from './style';
export default Layout;
